import handler from './Handler'

export default ({
  // Auth
  login: form => handler.post('/auth/login', form),
  logout: () => handler.post('/auth/logout'),
  getMe: () => handler.get('/users/me'),

  // Requestor
  getRequestors: ({ type, params }) => handler.get(`/${type}/users`, { params }),
  getRequestorDetail: ({ type, params }) => handler.get(`/${type}/user`, { params }),

  // User
  getUsers: ({ type, param }) => hadnler.get(`/${type}/users`, {param}),

  // Transaction
  getRole: () => handler.get('/groups'),
  getModules: () => handler.get('/transactions/modules'),
  getTransactions: params => handler.get('/transactions', { params }),
  getStatusDocuments: () => handler.get('/transactions/status-documents'),
  getTransactionDetail: id => handler.get(`/transactions/${id}`),
  getPicsBox: params => handler.get('/transactions/pics-box', { params }),
  getHistoryLogs: params => handler.get('/transactions/history-logs', { params }),
  submitTransactions: form => handler.post('/transactions/submit', form),
  approveTransactions: form => handler.post('/transactions/approve', form),
  sendBackTransactions: form => handler.post('/transactions/send-back', form)
})
